const defaultValue = {
  pageSize: 10
};

const parse = (value: string | null) => (value ? JSON.parse(value) : value);

export const getConfig = (key: string) =>
  parse(localStorage.getItem(key)) ?? defaultValue[key];

export const setConfig = (key: string, value: any) =>
  localStorage.setItem(key, JSON.stringify(value));
